var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-shopping-cart"}),_c('b-badge',{staticStyle:{"transform":"scale(0.8)"},attrs:{"pill":"","variant":"success"}},[_vm._v(_vm._s(_vm.cartCount))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }